export * from './splitter.module';
export * from './splitter.component';
export * from './area/area.component';
export * from './custom-gutter.directive';
export * from './types';
